import { Application, Applications, FileUploadAttributes, TicketPriority } from '@copetence/shared'
import { create } from 'zustand'

type CreateTicketState = {
    enquiries: {
        phone?: string,
        email: string,
    },
    app?: Application
    freeFormApp?: string
    problemDescription: string,
    uploadFiles: FileUploadAttributes[],
    priority: TicketPriority,
    milestoneId: string,
    ticketCategoryId?: string
    ref?: string
}

type CreateTicketActions = {
    setEnquiriePhone: (phone: string) => void
    setEnquirieEmail: (email: string) => void
    setApp: (app: string) => void
    setFreeFormApp: (app: string) => void
    setProblemDescription: (desc: string) => void
    setUploadFiles: (files: FileUploadAttributes[]) => void
    removeUploadFile: (fileId: FileUploadAttributes["id"]) => void
    setPriority: (priority: TicketPriority) => void
    setMilestoneId: (milestoneId: string) => void
    setTicketCategoryId: (categoryId?: string) => void
    setRef: (ref?: string) => void
    clear: () => void
}

const initialCreateTicketState: CreateTicketState = {
    enquiries: { email: "" },
    problemDescription: "",
    uploadFiles: [],
    priority: TicketPriority.LOW,
    milestoneId: "Default Milestone"
}

export const useCreateTicketState = create<CreateTicketState & CreateTicketActions>()((set, get) => ({
    ...initialCreateTicketState,
    setEnquiriePhone: (phone) => set({ enquiries: { ...get().enquiries, phone } }),
    setEnquirieEmail: (email) => set({ enquiries: { ...get().enquiries, email } }),
    setApp: (app) => {
        const a = Applications.find(a => a.id === app)
        if (!a) return
        set({ app: a })

        if (a.milestones) {
            const defaultMilestone = a.milestones.find(m => m.defaultMilestone)
            if (defaultMilestone) set({ milestoneId: defaultMilestone.id })
        } else {
            set({ milestoneId: "Default Milestone" })
        }
    },
    setFreeFormApp: (app) => set({ freeFormApp: app }),
    setProblemDescription: (desc) => set({ problemDescription: desc }),
    setUploadFiles: (files) => set({ uploadFiles: files }),
    removeUploadFile: (fileId) => set({ uploadFiles: get().uploadFiles.filter(uploadFile => uploadFile.id !== fileId) }),
    setPriority: (priority) => set({ priority }),
    setMilestoneId: (milestoneId) => set({ milestoneId }),
    setTicketCategoryId: (categoryId) => set({ ticketCategoryId: categoryId }),
    setRef: (ref) => set({ ref }),
    clear: () => set({ ...initialCreateTicketState })
}))